import { useQuery } from "@tanstack/react-query";
import type { SellerWithStoresResponse } from "@/lib/api/types";
import { endpoints } from "@/lib/api/endpoints";
import { apiJsonClient } from "@/lib/query/core/api-json-client";
import { queryKeys } from "@/lib/query/core/query-keys";

/**
 * The store's owner, for the store page's title bar (name + phone). The store
 * detail response carries only the seller's id. Same key and endpoint as the
 * sellers module's seller query, so the two share one cache entry — this is a
 * copy rather than an import because modules do not import each other.
 */
export function useStoreOwnerQuery(sellerId: string) {
  const query = useQuery({
    queryKey: queryKeys.admin.sellerById(sellerId),
    queryFn: () =>
      apiJsonClient<SellerWithStoresResponse>(
        endpoints.admin.sellerById(sellerId),
      ),
    enabled: sellerId.length > 0,
  });
  return { data: query.data };
}
